/**
 * Focal component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import styled from 'styled-components';

/**
 * Styled focal component.
 */
const Focal = styled.span<React.CSSProperties>`
  color: ${Colors.modal.title};
  font-family: ${Fonts['bold']};
`;

export default Focal;
